import Image from 'next/image'

export default function MarineCitizenshipIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/marine-citizenship-colour.png' : '/images/icons/marine-citizenship-grey.png' } alt="Marine Citizenship icon" />  
  )
}
